import React, { useEffect, useState } from 'react';
import api from '../api';
import { clearDevApiDebug, subscribeDevApiDebug } from '../utils/devApiDebug';
import styles from './DevApiDebugPanel.module.css';

const DevApiDebugPanel = () => {
  const [open, setOpen] = useState(false);
  const [entries, setEntries] = useState([]);

  useEffect(() => subscribeDevApiDebug(setEntries), []);

  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  const errorCount = entries.length;

  return (
    <div className={`${styles.panel} ${open ? '' : styles.collapsed}`}>
      <button
        type="button"
        className={styles.toggle}
        onClick={() => setOpen((v) => !v)}
      >
        Dev API {errorCount ? `(${errorCount})` : ''} — tap to {open ? 'hide' : 'show'}
      </button>
      {open && (
        <div className={styles.body}>
          <div className={styles.meta}>
            <div>Page: {window.location.origin}</div>
            <div>API base: {api.defaults.baseURL || '(unset)'}</div>
          </div>
          <div className={styles.actions}>
            <button type="button" className={styles.clear} onClick={clearDevApiDebug}>
              Clear
            </button>
          </div>
          {entries.length === 0 ? (
            <p className={styles.empty}>No failed API calls logged yet.</p>
          ) : (
            entries.map((entry) => (
              <div key={entry.id} className={styles.entry}>
                <div className={styles.entryHead}>
                  {entry.at} · {entry.source} · {entry.method}
                  {entry.status != null ? ` · ${entry.status}` : ''}
                  {entry.code ? ` · ${entry.code}` : ''}
                </div>
                <div className={styles.entryUrl}>{entry.url}</div>
                <div className={styles.entryMsg}>{entry.message}</div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default DevApiDebugPanel;
